import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { callAPI, useUser, useStore } from "../../Utils/utils";
import { errorMessages } from "../../Constants/Errors";
import Alert from "../../Components/Alert/Alert";
import Layout from "../../Components/Global/Layout";
import Message from "../../Components/Message/Message";
import Loader from "../../Components/Global/Loader/Loader";
import BreadCrumb from "../../Components/Global/BreadCrumb/BreadCrumb";
import BlogCategoryEdit from "../../Components/BlogCategory/BlogCategoryEdit/BlogCategoryEdit";
import ErrorMessage from "../../Components/Global/ErrorMessage";
import {
  item_required_error_message,
  alert_message_type,
} from "../../Constants/Messages";

const BlogCategoryEditPage = () => {
  var { id } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();
  const [alert, setAlert] = useState();
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [formValues, setformValues] = useState({});
  const [refreshCount, setRefreshCount] = useState(0);
  const [storeName, setStoreName] = useState([]);
  const { store, setStore } = useStore();

  useEffect(() => {
    if (storeName?.length == 0 || storeName == undefined) {
      setStoreName(() => [store?.name]);
    } else {
      setStoreName((existingStoreId) => [...existingStoreId, store?.name]);
    }
  }, [store?.id]);

  useEffect(() => {
    if (storeName[1] != undefined) {
      if (storeName[0] != storeName[1]) {
        navigate("/admin");
        setStoreName([]);
      }
    }
  }, [storeName]);

  useEffect(() => {
    if (id) {
      callAPI(
        `/admin/blog-categories/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            token: user?.auth_token,
          },
        },
        navigate,
        setLoading,
      ).then((data) => {
        if (data?.success === true) {
          setformValues(data?.record);
        } else {
          setErrors(data?.errors);
        }
      });
    }
  }, [refreshCount, id, navigate, user?.auth_token]);

  const onUpdateBlogCategory = (MessageAction) => {
    if (MessageAction === alert_message_type?.success) {
      setAlert({
        text: "Saved successfully",
        type: alert_message_type?.success,
      });
      setRefreshCount(refreshCount + 1);
    } else if (MessageAction === alert_message_type?.error) {
      setAlert({
        text: item_required_error_message,
        type: alert_message_type?.error,
      });
    }
  };

  return (
    <Layout>
      {loading && <Loader className={"page_loader"} />}

      {!loading && (
        <>
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div className="d-flex flex-column">
              <BreadCrumb value={formValues["name"]} />
            </div>
          </div>

          {alert &&
          (alert?.text === "Saved successfully" ||
            alert?.text === item_required_error_message) ? (
            <div className="text-center">
              <Alert
                text={alert?.text}
                type={alert?.type}
                setAlert={setAlert}
              />
            </div>
          ) : (
            ""
          )}

          {errors ? (
            <div className="card">
              <div className="card-body defaultText">
                <p className="text-center">
                  <Message
                    text={
                      errorMessages[
                        ErrorMessage({ fieldName: "blog category", errors })
                      ]
                    }
                    type={"normal"}
                    showMessage={true}
                  />
                </p>
              </div>
            </div>
          ) : (
            <BlogCategoryEdit onUpdateCategory={onUpdateBlogCategory} />
          )}
        </>
      )}
    </Layout>
  );
};
export default BlogCategoryEditPage;
